module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    staticStyle: {
      "padding-left": "50px"
    }
  }, [_c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "the-north-sea"
    }
  }, [_c('div', {
    staticClass: "section level4",
    attrs: {
      "id": "part-2-lowlands"
    }
  }, [_c('div', {
    staticClass: "section level5",
    attrs: {
      "id": "groningen-the-netherlands-19301949"
    }
  }, [_c('div', [_c('p', {
    staticStyle: {
      "width": "550px",
      "padding-top": "20px",
      "font-size": "10pt",
      "font-family": "calibri"
    }
  }, [_vm._v("Our house stood on the corner of the market square and Boteringe Street. My friend Jan lived in the next street that led to the square, Ebbinge Street. From the age of six, Jan was my friend because we could not only play but also discuss practical matters like not peeing into the wind, and weighty matters like the question where babies actually came from. For a while I believed boys’ balls where eggs and that if they were placed in a girl they would incubate and become babies, but the details of the transfer escaped me.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "550px",
      "font-size": "10pt",
      "font-family": "calibri"
    }
  }, [_vm._v("Connecting our two streets was a small alley that hooked around the printing works of Hoitsema. I would walk through it every day to pick up Jan at his place, after which we would walk to school together. After the Nazi invasion, and when my recurring dreams of deserted cities had finally faded, I started to dream that I walked through the alley but that, on Hoitsema’s corner a giant would loom up behind a high brick wall and step over it. He would pick me up and throw me into the small yard that was at the back of Jan’s house. Night after night I went through the nightmare – I could not stop it. This was strange because, until then, I had been able to steer my dreams. I would remember where I got to last time and then dream on; a kind of feuil- leton dreaming in which I had amazing adventures.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "550px",
      "font-size": "10pt",
      "font-family": "calibri"
    }
  }, [_vm._v("The school Jan and I went to was a Christian school, in which Bible classes were part of the curriculum. It was a good school but when we advanced to grade five I thought that the teacher there was crazy. He told us that some people said that when, as part of the plagues of Egypt, the River Nile turned to blood this was not actual blood but red soil that was washed downriver by heavy rains in inland Africa. When I heard this I felt relieved, what a sensible explanation! Yet the teacher told us that the people who said so were wrong, the Bible said it was blood and therefore it was blood – and his voice would go into overdrive so that the word ‘blood’ peeped out as if it was the cry of a caged and much agonised bird.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "550px",
      "font-size": "10pt",
      "font-family": "calibri"
    }
  }, [_vm._v("From that time onward, I started to look critically at what I was told. I argued that, if God was Truth, and if we were created in his image, we should also reflect truth. It did not take me long to discover that it was true that God was created in our image. I discovered this when I found a reproduction of Michelangelo’s Creation of Adam, showing God as a white-bearded man dressed in a swirling cloak. After that, I thought of God as that which we do not know. When Jan said that, surely, this was belittling God, I argued that people knew more all the time, therefore we became aware of more things that we did not yet know, and therefore God became greater with each bit of new knowledge. Later, I grew comfortable with the essence of this view. Gradually, I realised that my thoughts were very different from what I was being taught.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "550px",
      "font-size": "10pt",
      "font-family": "calibri"
    }
  }, [_vm._v("My parents, although progressive and widely regarded as modern, were bound by the teachings of the Reformed Church. We went to church twice every Sunday. As a small child, I passed the time in church by blowing channels in the soft black fur of my mother’s coat but now that I was growing")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b6d2b0d4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Section0023.vue
// module id = 129
// module chunks = 0